module.exports = __webpack_public_path__ + "static/media/blindspot.8cd1f104.png";